"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPreviousSlide = void 0;
var _constants = require("../constants");
const isPreviousSlide = ({
  currentSlide,
  maxVisibleItems = _constants.MAX_VISIBLE_PAGINATION_ITEMS,
  slidesCount,
  slideIndex
}) => slidesCount > maxVisibleItems && slideIndex === currentSlide - 2;
exports.isPreviousSlide = isPreviousSlide;
//# sourceMappingURL=isPreviousSlide.js.map